import { Incarico } from './incarico';
import { Model } from './model';

export class AggiornamentoIncarico extends Model {
  note: string;
  static apiUrl: string = "aggiornamenti_incarico";

  incarico: Incarico;

  deserialize(input: any): AggiornamentoIncarico {
    let retV: AggiornamentoIncarico = new AggiornamentoIncarico();

    retV = super.deserialize(input) as AggiornamentoIncarico;

    if (input?.incarico) {
      retV.incarico = new Incarico().deserialize(input.incarico);
    }

    return retV;
  }
}
